import { render, staticRenderFns } from "./StockOriginList.vue?vue&type=template&id=40763605"
import script from "./StockOriginList.vue?vue&type=script&lang=js"
export * from "./StockOriginList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports